/**
 * Standard Switch/Toggle button styles
 * Used across the system to maintain consistency
 */

/**
 * Get standard switch styles
 * @param {boolean} isTable - If true, returns smaller size for tables
 * @returns {object} Switch sx styles
 */
export const getSwitchStyles = (isTable = false) => {
  const size = isTable
    ? {
        width: 36,
        height: 20,
        thumbSize: 14,
        translateX: 16,
        padding: (20 - 14) / 2, // 3px for perfect centering
      }
    : {
        width: 44,
        height: 24,
        thumbSize: 16,
        translateX: 20,
        padding: (24 - 16) / 2, // 4px for perfect centering
      };

  return {
    width: size.width,
    height: size.height,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: `${size.padding}px`,
      margin: 0,
      transitionDuration: "300ms",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&.Mui-checked": {
        transform: `translateX(${size.translateX}px)`,
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: "#10B981 !important",
          opacity: "1 !important",
          border: "none !important",
        },
        "&:hover": {
          backgroundColor: "rgba(16, 185, 129, 0.08)",
        },
      },
      "&:not(.Mui-checked)": {
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: "#D2D6DB !important",
          opacity: "1 !important",
          border: "none !important",
        },
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
      },
      "&.Mui-disabled": {
        "& + .MuiSwitch-track": {
          opacity: "0.5 !important",
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: size.thumbSize,
      height: size.thumbSize,
      borderRadius: "50%",
      backgroundColor: "#fff !important",
      boxShadow:
        "0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)",
      transition: "background-color 300ms cubic-bezier(0.4, 0, 0.2, 1)",
    },
    "& .MuiSwitch-track": {
      borderRadius: 12,
      opacity: 1,
      transition: "background-color 300ms cubic-bezier(0.4, 0, 0.2, 1)",
      backgroundColor: "#D2D6DB",
    },
    "&.Mui-disabled": {
      "& .MuiSwitch-thumb": {
        backgroundColor: "#E5E7EB",
      },
      "& .MuiSwitch-track": {
        backgroundColor: "#E5E7EB",
        opacity: 0.5,
      },
    },
  };
};

